module.exports = __webpack_public_path__ + "img/racecourse-title-logo-hollywoodbets-kenilworth-white.276b696c.svg";